import './rules.css';

export default function Privacy() {
  return (
    <main className="policy-page">
      <h1>Privacy Rules for This Portfolio</h1>

      <ul className="policy-list">
        <li>This portfolio only collects information you provide voluntarily through the contact form.</li>
        <li>Contact submissions are transmitted using a third-party form service such as Web3Forms. That service may temporarily store or log submissions, so please review its policy for details.</li>
        <li>We do not sell or trade your contact information.</li>
        <li>If you want a specific contact submission removed, email <a href="mailto:pr4binpandey@gmail.com">pr4binpandey@gmail.com</a> and I will remove it where technically possible.</li>
        <li>Data is retained only as long as needed to reply to your inquiry or to meet legal obligations.</li>
        <li>The site is not intended for children under 13.</li>
        <li>Reasonable security measures are used, but no internet transmission can be guaranteed to be fully secure.</li>
        <li>Changes to these rules will be posted on this page with an updated effective date.</li>
      </ul>
    </main>
  );
}
